module.exports = __webpack_public_path__ + "img/hawaii.8e16c0cd.png";